import COLORS from "../constants/colors";

export function pageStyle() {
  return {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #F7F6F1 0%, #EEF4FB 100%)",
    padding: "1rem",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif',
    color: COLORS.text,
    boxSizing: "border-box",
  };
}

export function mainCardStyle() {
  return {
    maxWidth: "760px",
    margin: "0 auto",
    background: "rgba(255,255,255,0.78)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    borderRadius: "28px",
    padding: "0.8rem",
    boxShadow: "0 18px 48px rgba(76, 102, 130, 0.12)",
    border: "1px solid rgba(255,255,255,0.55)",
  };
}

export function smallTopBtnStyle(bg) {
  return {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    border: "none",
    background: bg,
    cursor: "pointer",
    fontSize: "1rem",
    color: COLORS.text,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };
}

export function primaryBtnStyle() {
  return {
    border: "none",
    borderRadius: "14px",
    padding: "0.9rem 1.2rem",
    background: COLORS.blue,
    color: "#fff",
    fontWeight: 700,
    cursor: "pointer",
  };
}

export function bigActionStyle(bg) {
  return {
    width: "100%",
    border: "none",
    borderRadius: "22px",
    padding: "1.2rem",
    background: bg,
    color: "#fff",
    fontSize: "1.35rem",
    fontWeight: 800,
    cursor: "pointer",
    boxShadow: "0 12px 24px rgba(0,0,0,0.08)",
    textAlign: "center",
  };
}

export function bigActionSubStyle() {
  return {
    fontSize: "0.92rem",
    marginTop: "0.35rem",
    opacity: 0.92,
    fontWeight: 500,
  };
}

export function bottomNavStyle() {
  return {
    marginTop: "1.4rem",
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    borderTop: "1px solid #E7E7E7",
    paddingTop: "1rem",
  };
}

export function bottomNavBtnStyle(active) {
  return {
    flex: 1,
    maxWidth: "180px",
    border: "none",
    borderRadius: "18px",
    background: active ? "#EEF4FB" : "transparent",
    padding: "0.85rem",
    cursor: "pointer",
    color: COLORS.text,
    fontWeight: 700,
  };
}

export function infoBoxStyle() {
  return {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(248, 251, 255, 0.95)",
    backdropFilter: "blur(10px)",
    border: "1px solid #DDE9F5",
    borderRadius: "16px",
    padding: "1.2rem 2rem",
    color: COLORS.text,
    fontSize: "1.1rem",
    fontWeight: 500,
    textAlign: "center",
    lineHeight: 1.7,
    zIndex: 10000,
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
    animation: "fadeInUp 0.3s ease-out",
  };
}

export function heroWordStyle(marginTop = 1.1) {
  return {
    fontSize: "2.7rem",
    fontWeight: 900,
    color: COLORS.text,
    textAlign: "center",
    marginTop: `${marginTop}rem`,
    lineHeight: 1.15,
    cursor: "pointer",
    wordBreak: "break-word",
  };
}

export function centerSubStyle() {
  return {
    textAlign: "center",
    color: COLORS.subtext,
    marginTop: "0.45rem",
  };
}

export function blankMaskStyle() {
  return {
    height: "50px",
    borderRadius: "14px",
    background: "#F7F7F8",
    border: "1px dashed #D6D8DE",
  };
}

export function exampleBoxStyle() {
  return {
    marginTop: "1.2rem",
    marginBottom: "1.2rem",
    background: "#FFFDF8",
    border: "1px solid #EFE5D5",
    borderRadius: "18px",
    padding: "1rem",
    textAlign: "center",
    lineHeight: 1.8,
  };
}

export function hintBtnStyle() {
  return {
    border: "1px solid rgba(0,0,0,0.08)",
    background: "#ffffff",
    borderRadius: "18px",
    padding: "0.9rem 1.2rem",
    cursor: "pointer",
    color: COLORS.text,
    fontWeight: 700,
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  };
}

export function knowBtnStyle() {
  return {
    flex: 1,
    border: "none",
    borderRadius: "18px",
    background: "#fff",
    padding: "1rem",
    cursor: "pointer",
    fontWeight: 800,
    color: COLORS.text,
    boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
  };
}

export function btnBarStyle(color) {
  return {
    width: "42px",
    height: "4px",
    borderRadius: "999px",
    background: color,
    margin: "0.55rem auto 0",
  };
}

export function reviewBtnStyle(bg) {
  return {
    flex: 1,
    minWidth: "120px",
    border: "none",
    borderRadius: "16px",
    background: bg,
    padding: "1rem",
    cursor: "pointer",
    color: "#fff",
    fontWeight: 800,
    fontSize: "1rem",
  };
}

export function overlayStyle() {
  return {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "1rem",
  };
}

export function modalStyle() {
  return {
    maxWidth: "460px",
    width: "100%",
    background: "#fff",
    borderRadius: "24px",
    padding: "1.5rem",
    textAlign: "center",
    boxShadow: "0 24px 50px rgba(0,0,0,0.16)",
  };
}

export function detailTagStyle(active, color) {
  return {
    border: "none",
    borderRadius: active ? "16px" : "999px",
    background: active ? color : "#F1F3F5",
    color: active ? "#fff" : COLORS.text,
    padding: active ? "0.75rem 1rem" : "0.5rem 0.9rem",
    cursor: "pointer",
    fontWeight: 700,
    transition: "all .2s ease",
    transform: active ? "scale(1.04)" : "scale(1)",
  };
}

export function detailPanelStyle() {
  return {
    background: "#fff",
    borderRadius: "16px",
    padding: "1rem",
    border: `1px solid ${COLORS.line}`,
  };
}

export function contentSectionStyle() {
  return {
    background: "#fff",
    borderRadius: "20px",
    padding: "1rem",
    border: `1px solid ${COLORS.line}`,
    marginBottom: "1rem",
  };
}

export function sectionTitleStyle() {
  return {
    fontSize: "1.05rem",
    fontWeight: 800,
    color: COLORS.text,
    marginBottom: "0.8rem",
  };
}

export function listCardStyle() {
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
    background: "#FAFBFC",
    borderRadius: "14px",
    padding: "0.9rem",
    border: `1px solid ${COLORS.line}`,
  };
}

export function miniBtnStyle() {
  return {
    border: "none",
    borderRadius: "10px",
    background: COLORS.blue,
    color: "#fff",
    padding: "0.55rem 0.85rem",
    cursor: "pointer",
    fontWeight: 700,
  };
}

export function topInfoBarStyle() {
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "1rem",
    marginBottom: "1rem",
  };
}

export function homeTitleWrapStyle() {
  return {
    textAlign: "center",
    marginBottom: "1.1rem",
  };
}